import { useParams } from 'react-router';
import { IScenario } from '@/types';
import { getUrl } from '@/utils/api';

function useScenario(id?: string) {
  const { scenarioId } = useParams<{ scenarioId: string }>();
  const query = getUrl(`v1/scenarios/${id ? id : scenarioId}`);
  return {
    ...query,
    data: query.data as IScenario,
  };
}

export default useScenario;
